import { render, staticRenderFns } from "./fireTruckMg.vue?vue&type=template&id=ca35427a&scoped=true&"
import script from "./fireTruckMg.vue?vue&type=script&lang=js&"
export * from "./fireTruckMg.vue?vue&type=script&lang=js&"
import style0 from "./fireTruckMg.vue?vue&type=style&index=0&id=ca35427a&prod&lang=scss&scoped=true&"
import style1 from "./fireTruckMg.vue?vue&type=style&index=1&id=ca35427a&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ca35427a",
  null
  
)

export default component.exports